const BASE_URL = "https://whc.caringnri.com/api";

export const API_URL = {
    COUNT_GETALL: `${BASE_URL}/visit-counts`,
    SEND_EMAIL: `${BASE_URL}/send-email`,
};
